require('./bootstrap');

import Carousel from 'vue-owl-carousel'
import Vue from 'vue'
import router from './router'
import store from './store'
import App from '../views/App'
import AnimatedIcon from '../views/components/AnimatedIcon'
import Buscador from '../views/components/Buscador'
import Recientes from '../views/components/Recientes'
import Menu from '../views/components/Menu'
import moment from 'moment'
import 'moment/locale/es';
Vue.prototype.moment = moment
Vue.use(require('vue-moment'));
import Datepicker from 'vuejs-datepicker';
import Notifications from 'vue-notification'
import {MikePad} from 'vue-loading-spinner'

Vue.component('vuejs-datepicker',Datepicker);

Vue.component('animated-icon',AnimatedIcon);
Vue.component('buscador-component',Buscador);
Vue.component('recientes-component',Recientes);
Vue.component('menu-component',Menu);
Vue.component('carousel',Carousel);
Vue.component('spinner',MikePad);
Vue.use(Notifications)

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!store.getters.loggedIn) {
            next({
                name: 'login',
            })
        } else {
            next()
        }
    } else {
        next() // make sure to always call next()!
    }
})

axios.interceptors.response.use(function (response) {
    return response
}, function (error) {
    if (error.response.status === 401) {
        localStorage.removeItem('access_token')
        window.location.href = "/login";
    }
    return Promise.reject(error)
})

const app = new Vue({
    el: '#app',
    components: { App },
    router,
    store,
});


//    SET USERID
$(document).ready(function(){
    let uid = localStorage.getItem('user_id');
    if(uid == null && store.getters.loggedIn){
        store
        .dispatch("getPerfil")
        .then(response => {
            localStorage.setItem('user_id', response.data.id)
            gtag('set', {'user_id': response.data.id});
        })
        .catch(error => {
        });
    }else{
        gtag('set', {'user_id': uid});
    }
});
